{
  "slug": "spatial-rotation-questions",
  "title": "Spatial Rotation Questions and Strategies",
  "description": "Mental rotation preserves handedness; reflection reverses it. Work through examples, answers, and responsible practice advice.",
  "category": "Practice questions",
  "sections": [
    {
      "heading": "How to approach it",
      "paragraphs": [
        "Mental rotation preserves handedness; reflection reverses it.",
        "Work accurately before quickly. State the rule, test every step, then compare choices."
      ]
    },
    {
      "heading": "Practice set",
      "paragraphs": ["Try each prompt before reading its answer or strategy."],
      "bullets": [
        "Choose an anchor corner.",
        "Track clockwise feature order.",
        "Distinguish reflection from rotation.",
        "Use fixed 90° steps.",
        "Ignore page position.",
        "Compare relative distances."
      ]
    },
    {
      "heading": "Practice effects",
      "paragraphs": [
        "Practice improves familiarity and strategy, but a short exercise is not a standardized assessment.",
        "Use unfamiliar material and time between sessions for a more honest snapshot."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-score-ranges-explained"],
  "sources": [],
  "faqs": [
    {
      "question": "Does practice raise IQ?",
      "answer": "It can improve familiarity and specific strategies; that is not proof of broad permanent change."
    }
  ],
  "summary": "Mental rotation preserves handedness; reflection reverses it. Work through examples, answers, and responsible practice advice. Content reviewed 18 July 2026."
}
